const SIT_API_BASE_URL = `https://antheapi-qa.aakash.ac.in`
const SIT_CMS_BASE_URL = `https://cms-sit.aakash.ac.in`
const SIT_ANTHE_CMS_BASE_URL = `https://anthe-kell-cms.aakash.ac.in`
const SIT_JEE_MOCK_BASE_URL = `https://antheapi-qa.aakash.ac.in/examapi/get_exam_link`
const SIT_JEE_MOCK_TENANT_ID = 'be0de013-fe4d-11ee-ad85-0288ab69f014'
const SIT_JEE_MOCK_TENANT_TOKEN = 'jlq7K9msU2mEukfYk2hZP1BuXKc25ot2'
const SIT_TP_BASE_URL = 'https://testplayerapi-qa.aakash.ac.in/stage/test_player'
const SIT_TP_API_TOKEN = 'scholarship-website_R4tOTJq72gwx2Rex'

const PROD_API_BASE_URL = `https://antheapi.aakash.ac.in`
const PROD_CMS_BASE_URL = `https://aakashapi.aakash.ac.in`
const PROD_ANTHE_CMS_BASE_URL = `https://anthe-cms.aakash.ac.in`
const PROD_JEE_MOCK_BASE_URL = `https://antheapi.aakash.ac.in/examapi/get_exam_link`
const PROD_JEE_MOCK_TENANT_ID = 'be0de013-fe4d-11ee-ad85-0288ab69f014'
const PROD_JEE_MOCK_TENANT_TOKEN = 'jlq7K9msU2mEukfYk2hZP1BuXKc25ot2'
const PROD_TP_BASE_URL = 'https://testplayerapi-prod.aakash.ac.in/Prod/test_player'
const PROD_TP_API_TOKEN = 'scholarship-website_WXD3ZnuMa5k4IEE4'

export const eventConfig = {
    course_payment_successful: {
        iACST: true,
        MOCK_NEET: false,
    },
}

export const showRegistrationSteps = ['iACST', 'IAT']

const IPDATA_API = `https://api.ipdata.co/?api-key=2fd8098a9b861f684efb7e036869ebbf3d03439fc16111adeab58998&fields=city,latitude,longitude,postal,region,country_code`

const BASE_URL =
    process.env.REACT_APP_ENVIRONMENT === `production`
        ? {
            api: PROD_API_BASE_URL,
            cms: PROD_CMS_BASE_URL,
            anthe_cms: PROD_ANTHE_CMS_BASE_URL,
            jee_mock: PROD_JEE_MOCK_BASE_URL,
            jee_mock_tenant_id: PROD_JEE_MOCK_TENANT_ID,
            jee_mock_tenant_token: PROD_JEE_MOCK_TENANT_TOKEN,
            tp_base_url: PROD_TP_BASE_URL,
            tp_api_token: PROD_TP_API_TOKEN,
        }
        : {
            api: SIT_API_BASE_URL,
            cms: SIT_CMS_BASE_URL,
            anthe_cms: SIT_ANTHE_CMS_BASE_URL,
            jee_mock: SIT_JEE_MOCK_BASE_URL,
            jee_mock_tenant_id: SIT_JEE_MOCK_TENANT_ID,
            jee_mock_tenant_token: SIT_JEE_MOCK_TENANT_TOKEN,
            tp_base_url: SIT_TP_BASE_URL,
            tp_api_token: SIT_TP_API_TOKEN,
        }

let config = {
    LOGIN_API: `${BASE_URL.api}/examapi/login_access`,
    DASHBOARD_API: `${BASE_URL.api}/examapi/dashboard`,
    MASTER_API: `${BASE_URL.api}/examapi/master_data`,
    GENERATE_OTP_API: `${BASE_URL.api}/examapi/generate_login_otp`,
    VALIDATE_OTP_API: `${BASE_URL.api}/examapi/validate_login_otp`,
    START_MAIN_EXAM_API: `${BASE_URL.api}/examapi/start_main_journey`,
    PROFILE_API: `${BASE_URL.api}/examapi/profile`,
    FETCH_BRANCHES: `${BASE_URL.api}/examapi/get_nearest_center`,
    FETCH_SCHOOL_BOARD: `${BASE_URL.api}/examapi/get_exam_board`,
    FETCH_CLASS_STREAM: `${BASE_URL.api}/examapi/get_class_stream`,
    FETCH_EXAM_STATE: `${BASE_URL.api}/examapi/get_exam_states`,
    FETCH_EXAM_CENTRE: `${BASE_URL.api}/examapi/get_exam_centers`,
    FETCH_CENTRE_PAYMENT: `${BASE_URL.api}/examapi/get_center_payment_gateway_list`,
    FETCH_EXAM_DATE: `${BASE_URL.api}/examapi/get_exam_dates`,
    SEND_OTP_API: `${BASE_URL.api}/examapi/generate_register_otp`,
    VERIFY_OTP_API: `${BASE_URL.api}/examapi/validate_register_otp`,
    SIGNUP_API: `${BASE_URL.api}/examapi/register`,
    NEAREST_CENTRE: `${BASE_URL.api}/examapi/get_nearest_center_by_cord`,
    LEAD_INFO: `${BASE_URL.api}/examapi/get_lead_info`,
    SF_LEAD_INFO: `${BASE_URL.api}/examapi/get_lead_info_sf_id`,
    EXAM_INFO_API: `${BASE_URL.api}/api/exam_info`,
    SCHOOL_API: `${BASE_URL.api}/api/get-school-list/`,
    EXAM_DATES_API: `${BASE_URL.api}/api/exam_dates_slots`,
    UPDATE_EXAM_INFO_API: `${BASE_URL.api}/api/exam_info_update`,
    RESET_SAMPLE_EXAM_API: `${BASE_URL.api}/api/reset-sample`,
    FETCH_EXAM_SLOTS: `${BASE_URL.api}/examapi/get_exam_slots`,
    VALIDATE_COUPON_API: `${BASE_URL.anthe_cms}/api/validate-scholarship-coupon`,
    RESULT_API: `${BASE_URL.api}/api/user_result`,
    IACST_RESULT_API: `${BASE_URL.anthe_cms}/api/get-iacst-result`,
    FORGOT_PASSWORD: `${BASE_URL.api}/api/anthe_forgot_password`,
    PROFILE_UPDATE_API: `${BASE_URL.api}/api/profile-update`,
    MOCK_PAYMENT_API: `${BASE_URL.api}/api/payment-options`,
    EXIGENCY_DATE_TIME_API: `${BASE_URL.api}/api/exigency_registration_date_time_check`,
    EXIGENCY_GENERATE_OTP_API: `${BASE_URL.api}/api/exigency_generate_otp`,
    EXIGENCY_VERIFY_OTP_API: `${BASE_URL.api}/api/exigency_validate_otp`,
    EXIGENCY_USER_REGISTER_API: `${BASE_URL.api}/api/exigency_user_register`,
    FETCH_COURSE_DATA: `${BASE_URL.cms}/api/course/list`,
    PINCODE_API: `${BASE_URL.cms}/online-form/address`,
    COURSE_PAYMENT_API: `${BASE_URL.cms}/api/get-course-payment-data`,
    STATE_API: `${BASE_URL.cms}/online-form/state`,
    TP_TOKEN_API: `${BASE_URL.tp_base_url}/websiteToken`,
    TP_RESULT_DATA: `${BASE_URL.tp_base_url}/iacst-result`,
    TP_RESULT_DATA_ANTHE: `${BASE_URL.tp_base_url}/anthe-result`,
    EXAM_DATE_STATUS_URL : `${BASE_URL.api}/api/check-exam-date/`,
    TP_TOKEN_API_TOKEN: BASE_URL.tp_api_token,
    IPDATA: IPDATA_API,
    VERSION_BANNER: '1.0',
    TRUECALLER_POLL_API:
    process.env.REACT_APP_ENVIRONMENT === 'production'
        ? 'https://crystal-live01.aakash.ac.in/java/crystalApi/auth/user?'
        : 'https://crystal-live01-stage.aakash.ac.in/java/crystalApi/auth/user?',
    TRUECALLER_PARTNER_KEY: '5SeJx9783eef0399c4d28aa83444a86502a19',
    TRUECALLER_PARTNER_NAME: 'Aakash',
    AAKASH_PRIVACY_URL: 'https://aakash.ac.in/privacypolicy',
    AAKASH_TERMS_URL: 'https://aakash.ac.in/termsconditions',
    LEPTON_API_URL: 'https://api.leptonmaps.com/v1',
    LEPTON_API_TOKEN:
        'da84163694c8df35961b7256e7ffcd19004702fb8b23d580da16e51c0687cf5c',
    NEET_MOCK_TC: 'https://neet-mocktest.aakash.ac.in/neet-mock-test/tc',
    INVICTUS_TC: 'https://www.aakash.ac.in/iat-terms-and-conditions',
    INVICTUS_PRIVACYPOLICY: 'https://www.aakash.ac.in/iat-privacy-policy',
    JEE_MOCK_EXAM: `${BASE_URL.jee_mock}`,
    X_TENANT_TOKEN: BASE_URL.jee_mock_tenant_token,
    TENANT_TOKEN_ID: BASE_URL.jee_mock_tenant_id,
    TP_URL_LINK:`${BASE_URL.api}/examapi/get_examUrl`
}

export default config
